import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { buildCommittedStateExpiresAt } from 'tripPlanner/assistant/surfaceSnapshots/expiry'
import type { TripPlannerCommittedStateEntry } from 'tripPlanner/assistant/surfaceSnapshots/committedStateEntry'
import { formatFlightSearchDisplayText, type FlightSearchDisplayTextParams } from './formatFlightSearchDisplayText'

// Keyed per stop when a stop is present (matching `resolveSearchDefaults`'s own per-stop lookup),
// with a flat fallback key otherwise -- mirrors `TripChatRecentSearch.tripStopId`'s own nullable
// design: unlike hotel/experience search, flight search is genuinely reachable with no stop in
// context (e.g. searching flights before any stops exist yet).
export function buildLastFlightSearchCommittedStateEntry(
  stopId: number | null | undefined,
  params: FlightSearchDisplayTextParams,
): TripPlannerCommittedStateEntry {
  return {
    key: stopId !== null && stopId !== undefined ? `search:flight:stop:${stopId}` : 'search:flight',
    kind: 'last_flight_search',
    label: 'Last flight search',
    displayText: boundActivityDisplayText(formatFlightSearchDisplayText(params)),
    sourcePath: 'trip_planner.search.flight',
    dataClassification: 'personalised_surface',
    expiresAt: buildCommittedStateExpiresAt(),
  }
}
